// Generated code for Big.Entities.ZaakStatus.
// Edit _Enum.tst to change the generated output.

export enum ZaakStatus {
    onbekend = 0,
    wachtOpAanvraagformulier = 1,
    teRegistrerenAanvraag = 2,
    teControlerenOpCompleetheid = 3,
    opTeSchortenAanvraag = 4,
    wachtOpAanvullendeInformatie = 5,
    teBeoordelenOpInhoud = 6,
    opTeStellenVerzoekNadereToelichting = 7,
    wachtOpNadereToelichting = 8,
    opTeStellenVerzoekOordeelDiplomas = 9,
    wachtOpOordeelDiplomas = 10,
    teBepalenAfhandeling = 11,
    teBesprekenInTandemOverleg = 12,
    opTeStellenVerzoekDiplomawaardering = 13,
    wachtOpDiplomawaardering = 14,
    opTeStellenBeschikking = 15,
    teToetsenBeschikking = 16,
    opTeStellenVoorgenomenBesluit = 17,
    teToetsenVoorgenomenBesluit = 18,
    wachtOpReactieZienswijze = 19,
    opTeStellenAntwoordOpReactieZienswijze = 20,
    opTeStellenUitnodigingVoorZienswijzeGesprek = 21,
    opTeStellenVerslagZienswijzeGesprek = 22,
    teBeoordelenInBehandelingNemenAanvraag = 23,
    teBepalenVervolgTraject = 24,
    teBepalenAfhandelingCommissie = 25,
    stapTerugNaarEerdereStatusInProces = 26,
    wachtOpVerzoekZienswijzeGesprek = 27,
    teRegistrerenAanvullendOnderwijs = 28,
    opTeStellenUitstelBrief = 29,
    teToetsenUitstelBrief = 30,
    teVerifiërenDiplomas = 31,
    teRegistrerenDatumZitting = 32,
    opTeStellenPleitnota = 33,
    opTeStellenBriefInformatieAkvToetsEnPortfolioCbgv = 34,
    wachtOpBetalingAkvToetsCbgv = 35,
    opTeStellenBriefAanmeldingAkvToetsCbgv = 36,
    teRegistrerenAfspraakAkvToetsCbgv = 37,
    opTeStellenVerweerschrift = 38,
    opTeStellenBemiddelingsbrief = 39,
    wachtOpReactieBemiddelingsbrief = 40,
    teBepalenWijzeVanRappelleren = 41,
    opTeStellenRappelBriefInstelling = 42,
    opTeStellenRappelBriefBetaling = 43,
    startZaakB02715 = 44,
    opTeStellenMeldingDwjz = 45,
    startZaakH0081 = 46,
    startZaakB0091 = 47,
    opTeStellenBevestigingAfbrekenLopendeZaak = 48,
    zaakAfgesloten = 49,
    aanTeMakenMachtiging = 50,
    wachtOpAdviesOfUitspraak = 51,
    teRegistrerenUitslagAkvToetsCbgv = 52,
    opTeStellenMeldingDatumAkvToetsCbgv = 53,
    opTeStellenBriefAkvToetsNietBehaaldCbgv = 54,
    opTeStellenBriefAanbiedenMedischInhoudelijkeToetsCbgv = 55,
    wachtOpBetalingRegistratie = 56,
    wachtOpBetalingMedischInhoudelijkeToetsCbgv = 57,
    opTeStellenBriefAanmeldingMedischInhoudelijkeToetsCbgv = 58,
    teRegistrerenVerzoekTotUitstel = 59,
    startZaakB0121 = 60,
    wachtOpSupervisieverklaring = 61,
    wachtOpOndertekendeSupervisieovereenkomst = 62,
    teRegistrerenVerzoekVerlengingSupervisie = 63,
    teBeoordelenVerlengenSupervisie = 64,
    omTeZettenInschrijvingNaarOngeclausuleerd = 65,
    wachtOpBeoordelingsformulier = 66,
    opTeStellenOntvangstBevestigingBeoordelingsformulier = 67,
    teRegistrerenAfbrekenLopendeAanvraag = 68,
    opTeStellenAdviesCbgv = 69,
    aanTeMakenBevestigingVanInschrijving = 70,
    voorTeBereidenSchriftelijkeRondeCbgv = 72,
    voorTeBereidenVergaderingCbgv = 73,
    teBeoordelenUitkomstCbgv = 75,
    startZaakH0152 = 76,
    wachtOpPreAdviesCbgv = 77,
    teRegistrerenVergaderingCbgv = 78,
    opTeStellenBriefOverdragenAanCommissie = 79,
    opTeStellenBriefAfspraakAanvullendGesprekCbgv = 80,
    teRegistrerenTelefonischVerzoek = 81,
    wachtOpBevestigingDatumAanvullendGesprekCbgv = 82,
    opTeStellenVerslagAanvullendGesprekCbgv = 83,
    teToetsenAdviesCbgv = 84,
    opTeStellenVerslagBemiddelingsgesprek = 87,
    teRegistrerenAfwikkelingBezwaarschrift = 88,
    voorTeLeggenAanCbgv = 89,
    opTeStellenAanvullendVerweerschrift = 90,
    teRegistrerenOntvangstConceptBeslissingDwjz = 91,
    teRegistrerenVerzoekOpstellenOverwegingen = 92,
    opTeStellenInhoudelijkeOverwegingen = 93,
    teRegistrerenOntvangstBeslissingDwjz = 94,
    wachtOpAntwoordBezwaaradviescommissie = 95,
    startZaakR0081Automatisch = 96,
    startZaakR0081Handmatig = 97,
    teRegistrerenDoorhaling = 98,
    opTeStellenBeschikkingDoorhaling = 99,
    teToetsenBeschikkingDoorhaling = 100,
    opTeStellenBerichtgevingAanDerden = 101,
    teToetsenBerichtgevingAanDerden = 102,
    opTeStellenPublicatie = 103,
    teToetsenPublicatie = 104,
    teBepalenVervolgstapBezwaarEnBeroep = 105,
    startZaakR0071Handmatig = 106,
    opTeStellenBeschikkingSpecialisme = 107,
    teToetsenBeschikkingSpecialisme = 108,
    teBepalenVervolgstapMedischInhoudelijkeToetsCbgv = 109,
    voorTeBesprekenAdviesgesprek = 110,
    startZaakI0031 = 111,
    teBeantwoordenStandaardSchriftelijkVerzoek = 112,
    teBepalenBeantwoorderVerzoek = 113,
    teBeantwoordenNietStandaardSchriftelijkVerzoek = 114,
    teBeantwoordenSchriftelijkVerzoekStaf = 115,
    teToetsenNietStandaardAntwoord = 116,
    startZaakR0061 = 117,
    teRegistrerenUitspraakArtikelregistratie = 118,
    opTeStellenBeslissingBevoegdheidsbeperking = 119,
    teToetsenBeslissingBevoegdheidsbeperking = 120,
    wachtOpUitspraakOnherroepelijk = 121,
    startZaakH0154 = 122,
    teRegistrerenAfspraakMedischInhoudelijkeToetsCbgv = 123,
    opTeStellenMeldingDatumMedischInhoudelijkeToetsCbgv = 124,
    teRegistrerenUitslagMedischInhoudelijkeToetsCbgv = 125,
    teBepalenVervolgstapBeoordelenAssessmentCbgv = 126,
    teRegistrerenBeoordelingsformulierenCbgv = 127,
    opTeStellenBriefAfspraakAdviesgesprekAssessmentCbgv = 128,
    opTeStellenDiscussiepuntenlijstCbgv = 129,
    opTeStellenVerslagAdviesgesprekCbgv = 130,
    startZaakH0155 = 131,
    wachtOpReactieDatumAdviesgesprekAssessmentCbgv = 132,
    startZaakH0151 = 133,
    teBepalenUitstelVanBehandelingRibiz = 134,
    opTeStellenBriefUitstelVanBehandelingRibiz = 135,
    teToetsenBriefUitstelVanBehandelingRibiz = 136,
    teBepalenVervolgstapAkvToetsCbgv = 137,
    komendVanuitConversie = 138,
    startZaakR0071Automatisch = 139,
    teRegistrerenOndertekendAanvraagformulier = 140,
    wachtOpVerstrijkenTermijnVersturenBriefNabestaanden = 141,
    startZaakB0306 = 142,
    teKoppelenDiplomaUziRegister = 143,
    teBeoordelenDiplomaUziRegister = 144,
    startZaakAanvraagViaWebsite = 145,
    opTeStellenBeschikkingNietInBehandelingNemen = 146,
    opTeStellenRappelbriefAanvraagformulier = 147,
    registerenAanvraagVerklaring = 148,
    opTeStellenVerklaring = 149,
    teToetsenVerklaring = 150,
    opTeStellenKopieVerklaring = 151,
    opTeStellenBriefInformatieProcedureAanvrager = 152,
    opTeStellenBriefInformatieProcedureAanvragerCbgv = 153,
    teBepalenRouteCommissieCbgv = 154,
    startZaakR0091 = 155,
    opTeStellenWijzigingMaatregel = 156,
    teToetsenWijzigingMaatregel = 157,
    startZaakH0084 = 158,
    startZaakAanschrijvingHerregistratie = 159,
    wachtOpAanvraagHerregistratie = 160,
    wachtOpBetalingHerregistratie = 163,
    wachtOpTerugbetaling = 167,
    startZaakHerregistratie = 168,
    ingediendEnBetaald = 169,
    binnengekomenDocumentTePlaatsenInZaakdossier = 170,
    wachtOpBeoordelingsgroepHerregistratie = 171,
    opTeStellenBriefInformatieProcedureAanvragerNaAkvToets = 172,
    opTeStellenProcedurebriefAanvragerVoorleggenAanImi = 173,
    wachtenOpReactieImi = 174,
    startZaakVerklaring = 176,
    startZaakAanvragenBigLogin = 177,
    wachtOpActiverenBigLogin = 178,
    startZaakAanvragenNieuwWachtwoord = 179,
    wachtOpInvullenNieuwWachtwoord = 180,
    teRegistrerenReactieZienswijze = 182,
    teToetsenOpschorting = 183,
    teRegistrerenDocumentBijZaak = 184,
    wachtOpZienswijzeGesprek = 185,
    wachtOpAfleggenAkvToetsCbgv = 186,
    wachtOpAfleggenMedischInhoudelijkeToetsCbgv = 187,
    wachtOpAanvullendGesprekCbgv = 188,
    wachtOpBetalingHerkansingAkvToets = 189,
    teRegistrerenDatumAanvullendGesprekCbgv = 190,
    opTeStellenBriefInformatieNuffic = 191,
    wachtOpOntvangstDiplomaBijNuffic = 192,
    teRegistrerenReactieOpUitspraakArtikelregistratie = 193
}
(ZaakStatus as any).name = 'ZaakStatus';
